import { UsersContainer } from "./UsersContainer/UsersContainer";
import { PageContent } from "../../components/PageContent/PageContent";
import { strings } from "../../config/string";

export const UserPage = () => {
  return (
    <PageContent title={strings.userPage}>
      <UsersContainer />
    </PageContent>
  );
};
